<template>
  <div>
    <el-dialog
      :title="value.isCreate ? '新增强更配置项' : '修改强更配置项'"
      center
      :visible="true"
      @close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <el-form
        ref="form"
        :model="value.form"
        :rules="rules"
        label-width="150px"
        size="mini"
      >
        <el-form-item label="渠道：" prop="channelId">
          <channel-selector
            placeholder="请选择"
            @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange"
            enableFullChannels
            ref="channelSelector"
          >
          </channel-selector>
        </el-form-item>
        <el-form-item label="客户端特征类型：">
          <el-radio-group v-model="value.form.clientAttrType">
            <el-radio label="ip">ip</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="客户端特征值：" prop="clientAttrValue">
          <el-input
            v-model="value.form.clientAttrValue"
            :placeholder="clientAttrValuePlaceholder()"
            clearable
            style="width: 220px"
          ></el-input
          ><a
            @click="inputCuttentIp"
            style="margin-left: 10px; text-decoration: none; font-size: smaller"
            href="javascript:;"
            >（填入本设备所在网络的IP）</a
          >
        </el-form-item>
        <el-form-item label="最低可用版本：" prop="version">
          <el-input
            v-model="value.form.version"
            placeholder="比如1.0.1"
            clearable
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="强更新地址：" prop="url">
          <el-input
            v-model="value.form.url"
            clearable
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="value.form.remark"
            clearable
            style="width: 220px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");
import ChannelSelector from "@/components/ChannelSelector";

// 本弹窗名称
const DialogName = "EditForceUpdateConfigDialog";

export default {
  data() {
    return {
      value: {
        isCreate: true,
        id: "",
        form: {
          channelId: 0,
          clientAttrType: "ip",
          clientAttrValue: "",
          version: "",
          remark: "",
          url: "",
        },
      },
    };
  },
  components: {
    ChannelSelector,
  },
  created() {
    this.value = dialogutil.getData(DialogName);

    if (this.value.isCreate) {
      this.value = this.defaultData();
    }
  },

  computed: {
    rules() {
      return {
        clientAttrValue: [{ required: true, message: " ", trigger: "blur" }],
        version: [{ required: true, message: " ", trigger: "blur" }],
        url: [{ required: true, message: " ", trigger: "blur" }],
      };
    },
  },

  methods: {
    async onChannelSelectorReady() {
      if (!this.value.isCreate) {
        this.$refs.channelSelector.channelId = this.value.form.channelId;
      }
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.value.form.channelId = newChannelId;
    },
    /**
     * 默认的数据
     */
    defaultData() {
      return {
        isCreate: true,
        id: "",
        form: {
          channelId: 0,
          clientAttrType: "ip",
          clientAttrValue: "",
          version: "",
          remark: "",
          url: "",
        },
      };
    },

    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    create() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addAppForceUpdateConfig`,
            {
              entry: {
                clientAttrType: this.value.form.clientAttrType,
                clientAttrValue: this.value.form.clientAttrValue,
                version: this.value.form.version,
                remark: this.value.form.remark,
                channelId: this.value.form.channelId,
                url: this.value.form.url,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.close();
      });
    },

    /**
     * 更新
     */
    update() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateAppForceUpdateConfig`,
            {
              entry: {
                id: this.value.id,
                clientAttrType: this.value.form.clientAttrType,
                clientAttrValue: this.value.form.clientAttrValue,
                version: this.value.form.version,
                remark: this.value.form.remark,
                channelId: this.value.form.channelId,
                url: this.value.form.url,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.close();
      });
    },

    close() {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },

    clientAttrValuePlaceholder() {
      if (this.value.form.clientAttrType == "ip") {
        return "填一个ip（0.0.0.0代表所有ip）";
      } else {
        return "";
      }
    },

    async inputCuttentIp() {
      var resData = (await axios.get(`https://api.ipify.org/?format=json`, {}))
        .data;

      this.value.form.clientAttrValue = resData.ip;
    },
  },
};
</script>